import { observer } from 'mobx-react';
import React from 'react';
import { HomeStore } from '../stores/HomeStore';
import { TinkerBoxTable } from './TinkerBoxTable';

interface TinkerBoxesProps {
  store: HomeStore;
  onConnect: (tinkerBoxId: number) => void;
  onStop?: (tinkerBoxId: number) => void;
  hideIpAddress?: boolean;
}

export const TinkerBoxes: React.FC<TinkerBoxesProps> = observer(
  ({ onConnect, onStop, store, hideIpAddress = false }) => {
    if (
      store.tinkerboxes?.tinkerboxes &&
      store.tinkerboxes.tinkerboxes.length > 0
    ) {
      return (
        <TinkerBoxTable
          onStop={onStop}
          onConnect={onConnect}
          className="overflow-auto w-full block"
          tinkerBoxes={store.tinkerboxes.tinkerboxes}
          selectedTinkerBoxId={store.tinkerBoxId}
          connectionState={store.tinkerBoxConnection.connectionState}
          hideIpAddress={hideIpAddress}
        />
      );
    }
    return <p className="italic py-2">You don't have any Tinkerboxes</p>;
  }
);
